import { types, actions } from './requests'
export const DELETEWORK_TYPES = {
    ...types('DELETEWORK'),
}
export const DELETEWORK_ACTIONS = {
    ...actions('DELETEWORK'),
}
